module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-input-multy-value",
    class: {
      'inline': _vm.$props.inline, 'focus': _vm.focus, 'has-value': (_vm.val && _vm.val.length), 'no-value': (!_vm.val || !_vm.val.length)
    }
  }, [(_vm.$props.label) ? _c('label', [_vm._v(_vm._s(_vm.$props.label))]) : _vm._e(), _c('div', {
    staticClass: "zimv__value-container"
  }, [((_vm.val && _vm.val.length)) ? _c('div', {
    staticClass: "zimv__value"
  }, _vm._l((_vm.val), function(item) {
    return _c('div', {
      staticClass: "zimv__value-preview__item",
      on: {
        "click": function($event) {
          _vm.removeValue(item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item))])])
  })) : _vm._e(), ((_vm.$props.valueType) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    staticClass: "zimv__value-input",
    attrs: {
      "placeholder": _vm.$props.placeholder,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newValue) ? _vm._i(_vm.newValue, null) > -1 : (_vm.newValue)
    },
    on: {
      "keypress": _vm.onInputKeyPress,
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "change": function($event) {
        var $$a = _vm.newValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.newValue = $$c
        }
      }
    }
  }) : ((_vm.$props.valueType) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    staticClass: "zimv__value-input",
    attrs: {
      "placeholder": _vm.$props.placeholder,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.newValue, null)
    },
    on: {
      "keypress": _vm.onInputKeyPress,
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "change": function($event) {
        _vm.newValue = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    staticClass: "zimv__value-input",
    attrs: {
      "placeholder": _vm.$props.placeholder,
      "type": _vm.$props.valueType
    },
    domProps: {
      "value": (_vm.newValue)
    },
    on: {
      "keypress": _vm.onInputKeyPress,
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "zimv__add",
    class: {
      'disabled': (!_vm.newValue || !_vm.newValue.length)
    },
    on: {
      "click": _vm.addValue
    }
  }, [_c('md-icon', {
    staticClass: "small"
  }, [_vm._v("add")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b423990c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZInputMultyValue.vue
// module id = 1241
// module chunks = 0